import {
  Button,
  FormItem,
  Input,
  SearchMultiSelect,
  Select,
  Typography,
} from '@/components';
import LANGUAGES from '@/constants/Languages';
import Language from '@/entities/Language';
import Project from '@/entities/Project';
import { createRemoteProject } from '@/firebase/RemoteProject';
import { useState } from 'react';
import styles from './CreateProjectView.module.css';

interface CreateProjectViewProps {
  appId: string;
  projectCreated: (project: Project) => void;
}

const CreateProjectView = ({
  appId,
  projectCreated,
}: CreateProjectViewProps): JSX.Element => {
  const [mainLanguage, setMainLanguage] = useState<Language | undefined>(
    undefined,
  );
  const [languages, setLanguages] = useState<Language[]>([]);
  return (
    <div className={styles.view}>
      <Typography variant="titleLarge">Create a new project</Typography>
      <div className={styles.form}>
        <FormItem>
          <Typography variant="labelMedium">App Id</Typography>
          <Input disabled value={appId} />
        </FormItem>
        <FormItem>
          <Typography variant="labelMedium">App languages</Typography>
          <SearchMultiSelect
            placeholder="Languages"
            options={LANGUAGES}
            onChange={(values) => {
              setLanguages(values);
            }}
            getOptionKey={(language: Language) => {
              return language.code;
            }}
            getOptionLabel={(language: Language) => {
              return `${language.name} (${language.code})`;
            }}
          />
        </FormItem>
        <FormItem>
          <Typography variant="labelMedium">Main language</Typography>
          <Select
            placeholder="Choose an option"
            options={languages}
            getOptionKey={(option) => option.code}
            getOptionLabel={(option) => {
              return `${option.name} (${option.code})`;
            }}
            onChange={(value) => {
              setMainLanguage(value);
            }}
          />
        </FormItem>
        <Button
          label="Create project"
          onClick={async () => {
            const project = await createRemoteProject({
              appId: appId,
              mainLanguage: mainLanguage,
              languages: languages,
            });
            projectCreated(project);
          }}
        />
      </div>
    </div>
  );
};

export default CreateProjectView;
